import { IBookingScheduler } from '../../models'
import {
  BookingSchedulerTypeKeys,
  IAddBookingSchedulerAction,
  IAddBookingSchedulerSuccessfulAction,
  IAddingBookingSchedulerAction,
  IEditBookingSchedulerAction,
  IEditBookingSchedulerSuccessfulAction,
  IEditingBookingSchedulerAction,
  IFetchBookingSchedulersAction,
  IFetchBookingSchedulersSuccessfulAction,
  IRemoveBookingSchedulerAction,
  IRemoveBookingSchedulerSuccessfulAction,
  IRemovingBookingSchedulerAction,
  ISetIsFetchingBookingSchedulersAction,
  ISetSelectedBookingSchedulerModalAction
} from '../types'

export function fetchBookingSchedulersAction(): IFetchBookingSchedulersAction {
  return { type: BookingSchedulerTypeKeys.FETCH_BOOKING_SCHEDULERS }
}

export function isFetchingBookingSchedulersAction(): ISetIsFetchingBookingSchedulersAction {
  return { type: BookingSchedulerTypeKeys.FETCHING_BOOKING_SCHEDULERS }
}

export function fetchBookingSchedulersSuccessfulAction(schedulers: IBookingScheduler[]): IFetchBookingSchedulersSuccessfulAction {
  return { type: BookingSchedulerTypeKeys.FETCH_BOOKING_SCHEDULERS_SUCCESSFUL, payload: schedulers }
}

export function addBookingSchedulerAction(scheduler: IBookingScheduler): IAddBookingSchedulerAction {
  return { type: BookingSchedulerTypeKeys.ADD_BOOKING_SCHEDULER, payload: scheduler }
}

export function isAddingBookingSchedulerAction(): IAddingBookingSchedulerAction {
  return { type: BookingSchedulerTypeKeys.ADDING_BOOKING_SCHEDULER }
}

export function addBookingSchedulerSuccessfulAction(): IAddBookingSchedulerSuccessfulAction {
  return { type: BookingSchedulerTypeKeys.ADD_BOOKING_SCHEDULER_SUCCESSFUL }
}

export function editBookingSchedulerAction(scheduler: IBookingScheduler): IEditBookingSchedulerAction {
  return { type: BookingSchedulerTypeKeys.EDIT_BOOKING_SCHEDULER, payload: scheduler }
}

export function isEditingBookingSchedulerAction(): IEditingBookingSchedulerAction {
  return { type: BookingSchedulerTypeKeys.EDITING_BOOKING_SCHEDULER }
}

export function editBookingSchedulerSuccessfulAction(): IEditBookingSchedulerSuccessfulAction {
  return { type: BookingSchedulerTypeKeys.EDIT_BOOKING_SCHEDULER_SUCCESSFUL }
}

export function setSelectedBookingSchedulerModalAction(scheduler: IBookingScheduler | null): ISetSelectedBookingSchedulerModalAction {
  return { type: BookingSchedulerTypeKeys.SET_SELECTED_BOOKING_SCHEDULER_MODAL, payload: scheduler }
}

export function removeBookingSchedulerAction(): IRemoveBookingSchedulerAction {
  return { type: BookingSchedulerTypeKeys.REMOVE_BOOKING_SCHEDULER }
}

export function isRemovingBookingSchedulerAction(): IRemovingBookingSchedulerAction {
  return { type: BookingSchedulerTypeKeys.REMOVING_BOOKING_SCHEDULER }
}

export function removeBookingSchedulerSuccessfulAction(): IRemoveBookingSchedulerSuccessfulAction {
  return { type: BookingSchedulerTypeKeys.REMOVE_BOOKING_SCHEDULER_SUCCESSFUL }
}
